import React, { useState } from 'react';
import { Typography, Box } from '@mui/material';
import NumericPad from '../NumericPad';
import ActivityLayout from '../ActivityLayout';

function FindMissingNumber({ onBack, onCorrect, initialTimer = null, globalTimer = null, onGlobalTimeUp, score }) {
  const [sequence, setSequence] = useState(() => generateSequence());
  const [missingIndex, setMissingIndex] = useState(() => Math.floor(Math.random() * 5));
  const [emoji, setEmoji] = useState(null);
  const [showNext, setShowNext] = useState(false);
  const [userAnswer, setUserAnswer] = useState(null);

  function generateSequence() {
    const start = Math.ceil(Math.random() * 5);
    return Array.from({ length: 5 }, (_, i) => start + i);
  }

  const handleAnswer = (answer) => {
    if (showNext) return;
    
    const isCorrect = parseInt(answer) === sequence[missingIndex];
    setUserAnswer(answer);
    setEmoji(isCorrect ? '🎉' : '❌');
    setShowNext(true);

    if (isCorrect) {
      onCorrect();
    }
   
  };

  const handleNext = () => {
    setSequence(generateSequence());
    setMissingIndex(Math.floor(Math.random() * 5));
    setEmoji(null);
    setShowNext(false);
  };

  return (
    <ActivityLayout 
      onBack={onBack}
      timeLimit={initialTimer}
      globalTimeLimit={globalTimer}
      onTimeUp={() => {
        setEmoji('⏰');
        setShowNext(true);
      }}
      onGlobalTimeUp={onGlobalTimeUp}
      isPaused={showNext}
      score={score}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          position: 'relative',
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          Quel est le nombre manquant ?
        </Typography>

        <Box
          sx={{
            display: 'flex',
            gap: 2,
            justifyContent: 'center',
            mb: 4,
          }}
        >
          {sequence.map((num, index) => (
            <Typography
              key={index}
              variant="h4"
              sx={{
                width: '60px',
                height: '60px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '2px solid #ccc',
                borderRadius: '8px',
                backgroundColor: 'white',
                color: showNext && index === missingIndex ? (parseInt(userAnswer) === sequence[missingIndex] ? 'blue' : 'red') : 'black',
              }}
            >
              {index === missingIndex ? (showNext ? sequence[missingIndex] : '?') : num}
            </Typography>
          ))}
        </Box>

        <NumericPad onClick={handleAnswer} disabled={showNext} emoji={emoji} />

        {showNext && (
          <Box
            onClick={handleNext}
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              fontSize: '2rem',
            }}
          >
            {emoji} {emoji === '⏰' ? 'Time\'s up!' : 'Click to continue'}
          </Box>
        )}

        <div id="missing-number-display" style={{ marginTop: '10px', fontSize: '18px' }}></div>
      </Box>
    </ActivityLayout>
  );
}

export default FindMissingNumber;
